export const selectFlippers = state => state.flippers;

export const selectStripeRetailEnabled = state => state.flippers.stripeRetail;
